import {
  MdOutlineAccountBalance,
  MdOutlineBolt,
  MdOutlineLocalFireDepartment,
  MdOutlinePhoneInTalk,
  MdOutlineWaterDrop,
} from 'react-icons/md'
import { MenuItem } from '../types'

const utilityBillsMenu: MenuItem[] = [
  {
    icon: MdOutlineBolt,
    name: 'Electricity',
    path: '/purchases?tab=utilities&utility=electricity',
    code: 'purchases',
  },
  {
    icon: MdOutlineWaterDrop,
    name: 'Water',
    path: '/purchases?tab=utilities&utility=water',
    code: 'purchases',
  },
  {
    icon: MdOutlineLocalFireDepartment,
    name: 'Gas',
    path: '/purchases?tab=utilities&utility=gas',
    code: 'purchases',
  },
  {
    icon: MdOutlinePhoneInTalk,
    name: 'Telecommunications',
    path: '/purchases?tab=utilities&utility=telecommunications',
    code: 'purchases',
  },
  {
    icon: MdOutlineAccountBalance,
    name: 'Mortgage/Credit',
    path: '/purchases?tab=utilities&utility=mortgage',
    code: 'purchases',
  },
]

export default utilityBillsMenu
